/**
 * Constants for the account-created conversion signal cookie.
 * Kept dependency-free so the server auth route can import them without
 * dragging the client analytics stack (Sentry, consent helpers) into its bundle.
 */

export const ACCOUNT_CREATED_COOKIE_NAME = 'jc_account_created';

/** Set on every RETURNING login (first-ever logins get the account-created cookie instead). */
export const SIGNED_IN_COOKIE_NAME = 'jc_signed_in';

/** TTL for the signal cookies set by the auth callback. */
export const ACCOUNT_CREATED_COOKIE_MAX_AGE_SECONDS = 600;
